import { BookTitlesByPublicationSheet, Citation, ModelType } from '@livv/models';
import { Box } from '@mui/material';
import useTranslation from 'next-translate/useTranslation';
import { FC } from 'react';
import BlockTitle from '../components/BlockTitle';
import { InternalDocumentLink } from '@components/Links';
import OpenInNewCard from '@components/OpenInNewCard';
import { useFreemiumDialog } from '@utils/context/freemiumDialog';

interface CitationsForModelTypeProps {
    bookTitlesByPublicationSheet?: BookTitlesByPublicationSheet;
    citations: Citation[];
    modelType: ModelType;
}

const CitationsForModelType: FC<CitationsForModelTypeProps> = ({
    citations,
    modelType,
    bookTitlesByPublicationSheet,
}) => {
    const { lang, t } = useTranslation('common');
    const { openFreemiumDialog } = useFreemiumDialog();

    const alphabeticalSort = (citationA: Citation, citationB: Citation) => {
        return citationA.source.title.localeCompare(citationB.source.title, lang);
    };

    const renderOverTitle = (type: ModelType, id: string) => {
        return ModelType.PUBLICATION_SHEET === type
            ? bookTitlesByPublicationSheet?.[id]
            : undefined;
    };

    return (
        <Box>
            <BlockTitle
                modelType={modelType}
                modelTypeLabel={
                    ModelType.DECISION === modelType
                        ? t('citations.sameCaseDecision', { count: citations.length })
                        : undefined
                }
                title={t(`citations.${modelType}`, { count: citations.length })}
            />
            {citations.sort(alphabeticalSort).map(({ source: { id, title } }, index) =>
                openFreemiumDialog ? (
                    <OpenInNewCard
                        key={`citation-${modelType}-${id}-${index + 1}`}
                        dataTestId={`citation-${modelType}-link`}
                        label={title}
                        onClick={openFreemiumDialog}
                        overTitle={renderOverTitle(modelType, id)}
                        sx={{ cursor: 'pointer' }}
                    />
                ) : (
                    <InternalDocumentLink
                        key={`citation-${modelType}-${id}-${index + 1}`}
                        dataTestId={`citation-${modelType}-link`}
                        docId={id}
                        plainLink={false}
                        underlineLinkOnHover={false}
                        openInNewTab
                    >
                        <OpenInNewCard label={title} overTitle={renderOverTitle(modelType, id)} />
                    </InternalDocumentLink>
                ),
            )}
        </Box>
    );
};

export default CitationsForModelType;
